import { Link } from "react-router";
import { GLOBAL_COUNTRIES } from "@routes/Global/utils/constants";

/**
 * The list of keyword in the Global section.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12726-24311&m=dev
 */
const ByCountry = (): React.ReactElement => {
  return (
    <div
      data-testid="by-country-component"
      className="text-center lg:text-left"
    >
      <h4 className="font-poppins text-lg font-semibold text-gray-850">
        Read more
      </h4>

      {GLOBAL_COUNTRIES.map(({ id, name, urlPath }) => (
        <div key={id} className="mt-4 border-t border-blue-100 pt-4">
          <Link
            to={urlPath}
            reloadDocument
            className="font-poppins font-medium leading-normal text-gray-850 hover:underline"
          >
            {name}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default ByCountry;
